export const EmptyButton = ({
  highlightColourOn,
  highlightColourOff,
  backgroundColourOff,
  backgroundColourOn,
  textColorOn,
  textColorOff,
  text,
  isOn,
  onClick
}) => {
  const viewboxSize = 101.56 - 3

  return (
    <>
      <svg
        onClick={onClick}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 101.56 100.92"
      >
        <g id="Apartment_Finder_Icons" data-name="Apartment Finder Icons">
          <circle
            cx="51.1"
            cy="50.46"
            r="50.46"
            fill={isOn ? highlightColourOn : highlightColourOff}
          />
          <circle
            cx="49.34"
            cy="49.65"
            r="49.34"
            fill={isOn ? backgroundColourOn : backgroundColourOff}
          />
          <text
            textAnchor="middle"
            letterSpacing="0"
            transform={`translate(${viewboxSize / 2} 68.65)`}
            fontSize="56"
            fill={isOn ? textColorOn : textColorOff}
            fontFamily="Lora-Bold, Lora"
            fontWeight="500"
            // style="isolation:isolate"
          >
            {text}
          </text>
        </g>
      </svg>
    </>
  )
}

export const Bath = ({ number, on }) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.92 102.92">
        <g id="Map_pins" data-name="Map pins">
          <circle
            cx="51.46"
            cy="51.46"
            r="50.46"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            d="M69.19,23.09a10,10,0,0,0-7.14,3l-.51.52L59.76,24.8a5.56,5.56,0,0,0-7.86,0L49,27.7a.72.72,0,0,0,0,1L60.55,40.28a.73.73,0,0,0,.52.21.69.69,0,0,0,.51-.21l2.9-2.9a5.57,5.57,0,0,0,0-7.83l-1.9-1.95.52-.52a8.63,8.63,0,0,1,14.74,6.1V50.75H67.22a3.52,3.52,0,0,0-3.31-2.35H55.7a3.52,3.52,0,0,0-3.3,2.35H21.76a.73.73,0,0,0-.72.73v8.4a16.44,16.44,0,0,0,14.7,16.33v4.46a.73.73,0,1,0,1.46,0h0V76.29H63.34v4.38a.73.73,0,0,0,1.45.17.49.49,0,0,0,0-.17V76.18a16.44,16.44,0,0,0,14.48-16.3V33.18A10.1,10.1,0,0,0,69.19,23.09ZM64.66,33.45a4.09,4.09,0,0,1-1.2,2.9l-2.38,2.39L50.54,28.21l2.39-2.39a4.12,4.12,0,0,1,5.81,0L61,28.11h0l2.44,2.44A4.09,4.09,0,0,1,64.66,33.45Zm-11,18.47a2.07,2.07,0,0,1,2.06-2.07h8.21A2.07,2.07,0,0,1,66,51.92v14.4H53.64Zm24.18,8a15,15,0,0,1-15,15H37.46a15,15,0,0,1-15-15V52.21H52.18V67.05a.73.73,0,0,0,.73.72h13.8a.73.73,0,0,0,.75-.71h0V52.21H77.82Z"
            fill="#36194f"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="0.49"
          />
        </g>
      </svg>
    </>
  )
}
export const Bed = ({ number, on }) => {
  return (
    <>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 102.92 102.92"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            d="M34.51,46a1.3,1.3,0,0,0-1.28,1.28V84.53a1.29,1.29,0,0,0,2.57,0V76.1H92.2v8.43a1.29,1.29,0,0,0,2.57,0V59.43a1.29,1.29,0,0,0-2.57,0v1.84a4.82,4.82,0,0,0-2.2-.56H50.75c.24-5.34-5-5.74-9-5.41a5.07,5.07,0,0,0-5,5.09,4.19,4.19,0,0,0,0,.5,4.51,4.51,0,0,0-.94.38v-14A1.28,1.28,0,0,0,34.51,46ZM39.3,60.29c-.06-3.25,4.47-2.3,6.47-2.42a2.49,2.49,0,0,1,2.45,2.51c0,.11,0,.22,0,.33H39.3Zm-1.28,3H90a2.23,2.23,0,0,1,2.2,2.21v8H35.8v-8A2.22,2.22,0,0,1,38,63.28Z"
            transform="translate(-12.54 -14.45)"
            fill="#36194f"
          />
        </g>
        <g id="Apartment_Finder_Icons" data-name="Apartment Finder Icons">
          <circle
            cx="51.46"
            cy="51.46"
            r="50.46"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </svg>
    </>
  )
}
export const Compass = ({ number, on }) => {
  return (
    <>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 102.92 102.92"
      >
        <g id="Apartment_Finder_Icons" data-name="Apartment Finder Icons">
          <circle
            cx="51.46"
            cy="51.46"
            r="50.46"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <circle
            cx="51.45"
            cy="51.46"
            r="13.42"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="0.48"
          />
          <line
            x1="82.73"
            y1="51.46"
            x2="20.16"
            y2="51.46"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="1.43"
          />
          <line
            x1="51.21"
            y1="20.18"
            x2="51.69"
            y2="82.74"
            fill="none"
            stroke="#36194f"
            strokeMiterlimit="10"
            strokeWidth="1.43"
          />
        </g>
      </svg>
    </>
  )
}
